import * as api from '../../resources/dictionaries.api';
import actionTypes from './dictionaries.action-types';

export const fetchPrivilegeDisplayTypesDictionaryRequest = () => ({
  type: actionTypes.FETCH_PRIVILEGE_DISPLAY_TYPES_DICTIONARY_REQUEST,
});

export const fetchPrivilegeDisplayTypesDictionarySuccess = (displayTypes) => ({
  type: actionTypes.FETCH_PRIVILEGE_DISPLAY_TYPES_DICTIONARY_SUCCESS,
  displayTypes,
});

export const fetchPrivilegeDisplayTypesDictionaryFailure = () => ({
  type: actionTypes.FETCH_PRIVILEGE_DISPLAY_TYPES_DICTIONARY_FAILURE,
});

export const fetchPrivilegeDisplayTypesDictionary = (locale) => async (dispatch, getState) => {
  try {
    const { session } = getState();
    const localeToUse = locale || session.locale;
    dispatch(fetchPrivilegeDisplayTypesDictionaryRequest());
    const displayTypes = await api.fetchPrivilegeDisplayTypesDictionary(localeToUse);
    dispatch(fetchPrivilegeDisplayTypesDictionarySuccess(displayTypes));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('FETCH_PRIVILEGE_DISPLAY_TYPES', error);
    dispatch(fetchPrivilegeDisplayTypesDictionaryFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/app/actions/dictionaries/privilege-display-types-dictionary.actions.js